import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";

import "./myWorkout.scss";
import FilterPanel, { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";
import { resetField, getExercises, searchExercises, addExerciseToMyWorkout, getMyWorkouts } from "../../../store/actions";
import ExerciseCard from "../exercise/exerciseCard";
import KeywordSearch from "../../../sharedComponents/keywordSearch";
import Loader from "../../../sharedComponents/preloader";
import { objToQueryString, queryStringToJSON } from "../../../utils/common";
import NoRecipeImage from "../../../assets/images/no-recipes-found.png";

export const AddExercises = ({
	toggleAddPlanPanel,
	resetField,
	getExercises,
	exercises,
	history,
	next,
	addExerciseToMyWorkout,
	getMyWorkouts,
	isJournalEntry,
	onUpdate,
	isMyWorkoutList
}) => {
	const [atBottom, setAtBottom] = useState(false);
	const [list, setList] = useState([]);

	const [exerciseList, setExerciseList] = useState([]);
	const [loading, setLoading] = useState(true);
	const [showLoader, setShowLoader] = useState(true);
	const [fetching, setFetching] = useState(false);

	const [filters, setFilters] = useState({
		limit: 6
	});
	const [query, setQuery] = useState();

	useEffect(() => {
		const newFilters = { ...filters };
		setQuery(objToQueryString(newFilters));
	}, [filters]);

	useEffect(() => {
		if (query) {
			setExerciseList([]);
			setLoading(true);
			setShowLoader(true);
			isMyWorkoutList ? getExercises(`/not_in_plan?${query}`) : getExercises(`?${query}`);
		}
	}, [query, getExercises, isMyWorkoutList]);

	useEffect(() => {
		setExerciseList((prevState) => {
			setShowLoader(false);
			setAtBottom(false);
			if (exercises !== null && exercises.length === 0) {
				setLoading(false);
			}
			return [...prevState, ...(exercises !== null ? exercises : [])];
		});
	}, [exercises]);

	useEffect(() => {
		if (atBottom) {
			setFetching(next ? true : false);
			setLoading(next ? true : false);
		}
	}, [atBottom, next]);

	useEffect(() => {
		if (fetching) {
			isMyWorkoutList ? getExercises(`/not_in_plan?${next.split("?")[1]}`) : getExercises(`?${next.split("?")[1]}`);
			setShowLoader(true);
		}

		setFetching(false);
	}, [fetching, getExercises, isMyWorkoutList, next]);

	const searchAction = (event) => {
		setExerciseList([]);
		event && setFilters((prevState) => ({ ...prevState, ...queryStringToJSON(`?${event}`) }));
	};

	const [submitting, setSubmitting] = useState(false);

	const addNowToMyWorkout = () => {
		if (list.length) {
			setSubmitting(true);
			resetField("MyWorkout.toggleAddPlanPanel", false);
			const successHandler = (res) => {
				res.json().then((data) => {
					NotificationManager.success("Exercise added!", "", 5000);
					getExercises(`/not_in_plan?limit=6`);
					setExerciseList([]);
					getMyWorkouts();
				});
			};
			addExerciseToMyWorkout({ is_plan: 0, exercise: list.join() }, successHandler);
		} else {
			NotificationManager.warning("Please select exercise!", "", 5000);
		}
	};
	const updateExerciseList = (event) => {
		setSubmitting(false);
		if (isJournalEntry) {
			const initialValues = {
				exercise: event.id,
				type_of_activity: event.type
			};
			onUpdate(initialValues);
		} else {
			const filteredList = list && list.length > 0 ? list.filter((item) => item === event.id) : [];
			setList((prevState) =>
				filteredList && filteredList.length > 0 ? list.filter((item) => item !== event.id) : [...prevState, event.id]
			);
		}
	};

	const [resetSearch, setResetSearch] = useState(false);
	const cancelItems = () => {
		setList([]);
		setFilters({ limit: 6 });
		setResetSearch(!resetSearch);
		resetField("MyWorkout.toggleAddPlanPanel", false);
	};

	return (
		<FilterPanel
			className="add-exercise-panel hide-sub-header"
			show={toggleAddPlanPanel}
			toggle={cancelItems}
			toggleAtBottom={setAtBottom}
			title="Add Exercises"
			closeBtn>
			<PanelBody className="d-flex flex-column">
				<div className="row">
					<div className="col-8">
						<KeywordSearch
							placeholder="Search Exercises"
							searchField="name"
							searchAction={searchAction}
							listName="Exercises.exercisesResult"
							name="searchRecipe"
							reset={resetSearch}
						/>
					</div>
				</div>

				<div className="card-wrap">
					{exerciseList &&
						exerciseList.map((card, index) => {
							const isActive = list.indexOf(card.id) > -1;
							return (
								<ExerciseCard
									hasDropdown={false}
									key={index}
									cardInfo={card}
									onClick={(event) => {
										updateExerciseList(event);
									}}
									history={history}
									addToPlanBtn
									isActive={isActive}
								/>
							);
						})}
					{loading ? (
						<Loader show={showLoader} />
					) : (
							exerciseList.length === 0 && (
								<div className="alert alert-info text-center w-100 m-3 no-recipes-found">
									<img src={NoRecipeImage} alt="No exercises found" />
									<div>No exercises found!</div>
								</div>
							)
						)}
				</div>
			</PanelBody>
			<PanelFooter className="sticky-footer">
				<div className="text-right">
					<button className="btn text-primary-dark" onClick={cancelItems}>
						Cancel
					</button>
					<button
						className="btn btn-primary"
						disabled={submitting || !list.length}
						onClick={(event) => addNowToMyWorkout(event)}>
						<i className="icon icon-plus" />
						Add Now
					</button>
				</div>
			</PanelFooter>
		</FilterPanel>
	);
};

const mapDispatchToProps = { resetField, getExercises, searchExercises, addExerciseToMyWorkout, getMyWorkouts };

const mapStateToProps = (state) => {
	const { Exercises, MyWorkout } = state;
	return {
		toggleAddPlanPanel: get(MyWorkout, "toggleAddPlanPanel"),
		exercises: get(Exercises, "exercisesResult.results", []),
		next: get(Exercises, "exercisesResult.next")
	};
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AddExercises);
